import { render, staticRenderFns } from "./DkDivider.vue?vue&type=template&id=23792383&"
import script from "./DkDivider.vue?vue&type=script&lang=js&"
export * from "./DkDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports